<h1 mat-dialog-title class="error-dialog-title">
    {{ this.data.title }}
</h1>
<div mat-dialog-content class="error-dialog-content">
    {{ this.data.code}} - {{ this.data.detail }}
</div>
<mat-dialog-actions align="center">
    <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>